@if (showTalentPoolsIcon) {
  <rt-icon name="talent-pools" size="small-x"></rt-icon>
}
